$(document).ready(function(){
    // Select the parent div
    var parentDiv = $(".product-info__block-list");

    // Select the 2nd and 3rd child divs
    var secondChild = parentDiv.children('[data-block-type="price"]');
    var thirdChild = parentDiv.children('[data-block-type="@app"]').first();

    // Wrap the 2nd and 3rd child divs with a new parent div
    secondChild.add(thirdChild).wrapAll('<div class="new-parent-div"></div>');
});


/* $(document).ready(function() {
  if ($('.product-marine-vinyl-fabric .product-info__block-list .new-parent-div .product-info__block-item .v-stack .price-list sale-price').length > 0) {
    $('sale-price').after(' <span class="sale-text">per yard</span>');
  }
}); */

document.addEventListener("DOMContentLoaded", function() {
    var link = document.querySelector(".ht-google-map-button-area a");
    if (link) {
        link.classList.add("button");
    }
});
